import { useMemo } from "react";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioListQuery";
import { usePropertyListQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyListQuery";
import { ArchivedFilterEnum } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { categoryItemSubtitle } from "web_myplann/Portfolio/Helpers/categoryItemSubtitle";
import { categoryItemTitle } from "web_myplann/Portfolio/Helpers/categoryItemTitle";
import { usePortfolioCategories } from "web_myplann/Portfolio/Hooks/usePortfolioCategories";
import type { LinkableItemOption } from "web_myplann/Portfolio/Types/linkableItemOption";

export const useLinkableItemOptions = (enabled: boolean) => {
	const { t } = useResource();
	const { data: portfolioList } = usePortfolioListQuery({
		archived: ArchivedFilterEnum.Active,
		enabled,
	});
	const { data: propertyList } = usePropertyListQuery({
		archived: ArchivedFilterEnum.Active,
		enabled,
	});

	const portfolios = useMemo(
		() => portfolioList?.data ?? [],
		[portfolioList?.data],
	);
	const properties = useMemo(
		() => propertyList?.data ?? [],
		[propertyList?.data],
	);

	const categories = usePortfolioCategories(portfolios, properties);

	return useMemo<LinkableItemOption[]>(
		() =>
			categories
				.flatMap((category) => category.items)
				.map((item) => ({
					key: `${item.kind}-${item.data.id}`,
					title: categoryItemTitle(item, t),
					subtitle: categoryItemSubtitle(item),
					item,
					link: { kind: item.kind, id: item.data.id },
				})),
		[categories, t],
	);
};
